import React from 'react';
interface ServicePlanProps {
  title: string;
  price: string;
  description: string;
  imageUrl: string;
  stripeLink?: string;
}
export const ServicePlan = ({
  title,
  price,
  description,
  imageUrl,
  stripeLink = '#'
}: ServicePlanProps) => {
  return <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-141">
      <div className="w-full h-48 mb-4 overflow-hidden rounded-md" data-id="element-142">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-143" />
      </div>
      <h3 className="text-xl font-bold text-rose-900 mb-2" data-id="element-144">{title}</h3>
      <p className="text-2xl font-bold text-amber-500 mb-4" data-id="element-145">{price}</p>
      <p className="text-gray-600 text-center mb-6" data-id="element-146">{description}</p>
      <a href={stripeLink} className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-rose-900 hover:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 transition-colors duration-300 w-full" data-id="element-147">
        Get Started
      </a>
    </div>;
};